import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Navbar.css';
import logo from '../assets/logo-education.png';

const Navbar = () => (
  <nav className="navbar">
    {/* Logo on the far left */}
    <Link to="/" className="navbar-logo">
      <img src={logo} alt="ICity Education Logo" className="logo" />
    </Link>

    {/* Links on the right */}
    <ul className="nav-links">
      <li><Link to="/">Home</Link></li>
      <li><Link to="/about">About</Link></li>
      <li><Link to="/services">Services</Link></li>
      <li><Link to="/portfolio">Portfolio</Link></li>
      <li><Link to="/contact">Contact</Link></li>
    </ul>
  </nav>
);

export default Navbar;
